import { Helmet } from 'react-helmet-new';
import { useTranslation } from 'react-i18next';

const HrefLangTags = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const languages = {
    en: 'https://matwproject.org',
    fr: 'https://matwproject.org/fr',
    ar: 'https://matwproject.org/ar',
    de: 'https://matwproject.org/de',
    es: 'https://matwproject.org/es',
    nl: 'https://matwproject.org/nl',
  };

  const regionals = [
    { hreflang: 'en-gb', url: 'https://matwproject.org.uk' },
    { hreflang: 'en-ca', url: 'https://matwprojectca.org' },
    { hreflang: 'en-us', url: 'https://matwprojectusa.org' },
    { hreflang: 'en-id', url: 'https://matwprojectid.org' },
    { hreflang: 'fr-fr', url: 'https://matwprojectfr.org' },
    { hreflang: 'en-my', url: 'https://matwprojectmys.org' },
    { hreflang: 'en-sg', url: 'https://matwprojectsgp.org' },
  ];

  const langPrefixes = Object.keys(languages).filter(l => l !== 'en');
  const path = typeof window !== 'undefined' ? window.location.pathname.replace(new RegExp(`^/(${langPrefixes.join('|')})(?=/|$)`), '') : '/';

  return (
    <Helmet>
      {lang !== 'en' &&
        Object.entries(languages)
          .filter(([code]) => code !== 'en')
          .map(([code, baseUrl]) => <link key={code} rel="alternate" href={`${baseUrl}${path}`} hreflang={code} />)}

      {regionals.map(({ hreflang, url }) => (
        <link key={hreflang} rel="alternate" href={`${url}${path}`} hreflang={hreflang} />
      ))}

      <link rel="alternate" href={`https://matwproject.org${path}`} hreflang="x-default" />
    </Helmet>
  );
};

export default HrefLangTags;
